import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Cards } from '../../../shared/components/cards-engine/components/card/models/card.model';
import { CardUtils } from '../../../shared/components/cards-engine/components/card/utils/card.utils';
import { MarvelChampionsCards } from '../../models/cards';
import { RoomService } from '../../../shared/services/room.service';
import { UserService } from '../../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from '@angular/fire/database';
import { debounceTime } from 'rxjs/operators';
import { HubService } from '../../../shared/services/hub.service';
import { addDefaultDeckIfNoDecks } from './models/champions-mocked-deck.model';
import { PlayerService } from '../../../shared/services/player.service';
import { CardMarvelTag as Tag } from '../../models/cards.model';
import { EncounterUtils } from './models/encounter.model';
import { CardsCatalog } from '../../models/catalog.model';
import { MOCKED_PLAYERS } from './models/players-mocked.model';

@Component({
  selector: 'app-room-creation',
  templateUrl: './room-creation.component.html',
  styleUrls: ['./room-creation.component.scss']
})
export class RoomCreationComponent implements OnInit, OnDestroy {
  initialCreatedDate; // store the initial createdDate, will be use to know if the owner leaves the current room and create a new room.

  formGroup: FormGroup;

  cardsBucket: { villain?: Cards; player1?: Cards; player2?: Cards };

  textSectionTitle = {
    title: 'ROOM CREATION SETTINGS',
    subtitle: 'Pick up room settings'
  };

  championsDecks; //  = CHAMPIONS_DECKS;

  roomCreationId;
  roomRef;
  roomRefSubscription;

  isFirstFormChange = true; // dont updateHub at the first form change
  // TODO catalog
  bosses = [
    {
      targetName: 'KF_KRAKEN',
      name: 'Kraken',
      modules: []
    }
    /* {
      targetName: "RHINO",
      name: "Rhino (default)",
      modules: [
      ]
    } */
    /* {
      targetName: "KLAW",
      name: "Klaw (default)",
      modules: [
        {
          id: "normal",
          name: "Normal",
          modularDeckKeys: ["bombScare", "standard"]
        },
        {
          id: "hard",
          name: "Hard",
          modularDeckKeys: ["bombScare", "standard", "expert"]
        }
      ]
    } */
  ];

  get _userRestrictions() {
    let matchingRoomUser =
      this.formGroup.value.players &&
      this.formGroup.value.players.find(
        roomUser => roomUser.uid === this.user.uid
      );
    return this.userService.userRestrictions(matchingRoomUser);
  }

  get user() {
    return this.userService.user;
  }

  set user(user) {
    this.userService.user = user;
  }

  getBossByBossTargetName(bossTargetName: string) {
    return this.bosses.find(boss => boss.targetName === bossTargetName);
  }

  loading;

  constructor(
    public formBuilder: FormBuilder,
    private roomService: RoomService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private afd: AngularFireDatabase,
    private hubService: HubService,
    // private snackBar: MatSnackBar,
    private playerService: PlayerService
  ) {
    this.formGroup = this.formBuilder.group({
      boss: [null, Validators.required],
      bossLevel: [null], // keyforge , Validators.required
      createdAt: [null],
      nbPlayers: [null, Validators.required],
      players: [],
      roomId: null,
      roomName: [null, Validators.required],
      status: [null],
      tabKey: [null],
      key: [null],
      spectators: [],
      encounterNumber: [0]
    });
    // TODO improve debounce
    this.formGroup.disable();

    this.formGroup.valueChanges.pipe(debounceTime(1000)).subscribe(data => {
      if (this.formGroup.value.roomId) {
        this.router.navigate(['/mc/play/' + this.formGroup.value.roomId]);
      }
      if (this.isFirstFormChange) {
        this.isFirstFormChange = false;
        // this.formGroup.get("players").setValue(MOCKED_PLAYERS); // keyforge
      } else if (this.roomCreationId) {
        this.updateHub(this.roomCreationId, data);
      }
    });

    // set randomEncounters
  }

  ngOnInit() {
    addDefaultDeckIfNoDecks();
    this.championsDecks = JSON.parse(localStorage.getItem('decks'));
    // this.formGroup.get("boss").setValue(0);
    this.loading = true;
    this.route.params.subscribe(res => {
      this.roomCreationId = res.roomCreationId;
      this.roomRef = this.afd.list(`hub/${this.roomCreationId}`);
      this.roomRefSubscription = this.roomRef
        .snapshotChanges()
        .map(changes => {
          return changes.map(c => ({
            key: c.payload.key,
            value: c.payload.val()
          }));
        })
        .subscribe(roomDatas => {
          for (let roomData of roomDatas) {
            this.formGroup.get(roomData.key).setValue(roomData.value);
          }
        });
      // TODO observable
      setTimeout(() => {
        this.loading = false;
        this.addPlayerOrSpectator();
        if (this._userRestrictions.editForm) {
          this.formGroup.enable();
        }
      }, 2000);
    });
  }

  addPlayerOrSpectator() {
    const updatePlayers = this.formGroup.get('players').value;
    const playerAlreadyInPlayers = updatePlayers.find(
      player => player.uid === this.user.uid
    );
    if (!playerAlreadyInPlayers) {
      let userToAddInList = {
        displayName: this.user.displayName,
        roles: [], // ['host', 'player'],
        /* img: 'https://lh5.googleusercontent.com/-2uuoiiO5cmE/AAAAAAAAAAI/AAAAAAAAAAA/AKF05nC7QrGTekqgoyNoqEDMUJvT9GFXiw/photo.jpg', */
        uid: this.user.uid,
        img: this.user.photoURL ? this.user.photoURL : null
      };

      const isNbMaxPlayerReach =
        this.formGroup.get('players').value.length >=
        this.formGroup.get('nbPlayers').value;
      if (isNbMaxPlayerReach || UserService.isVisitor(this.user)) {
        userToAddInList.roles = ['spectator'];
      } else {
        userToAddInList.roles = ['player'];
        // userToAddInList.champion = 'captainAmerica';
      }

      updatePlayers.push(userToAddInList);
      this.hubService.updateHub(
        this.roomCreationId + '/players',
        updatePlayers
      );
    }
  }

  ngOnDestroy() {
    this.roomRefSubscription.unsubscribe();
  }

  getPlayerByUid(uid: string) {
    let result;
    const playerObj = this.formGroup
      .get('players')
      .value.find(player => player.uid === this.user.uid);
    return playerObj;
  }

  isHostPlayer(uid: string) {
    let result;
    const player = this.getPlayerByUid(uid);
    if (player) {
      result = player.roles.includes('host');
    }
    return result;
  }

  get players() {
    const allPlayers = this.formGroup.get('players').value;
    const truePlayers = allPlayers
      ? this.formGroup
          .get('players')
          .value.filter(
            player => player.roles && player.roles.includes('player')
          )
      : [];
    return truePlayers;
  }

  get spectators() {
    const players = this.formGroup.get('players').value;
    const spectators = players
      ? this.formGroup
          .get('players')
          .value.filter(
            player => player.roles && player.roles.includes('spectator')
          )
      : [];
    return spectators;
  }

  get marvelChampionsCards() {
    return JSON.parse(JSON.stringify(MarvelChampionsCards));
  }

  createGameDatas() {
    const selectedBoss = this.getBossByBossTargetName(
      this.formGroup.value.boss
    );
    let selectedBossModule = selectedBoss.modules.find(
      module => module.id === this.formGroup.value.bossLevel
    );

    // if random
    if (!selectedBossModule) {
      const randomCardsEncounterCategoryWithoutVillain = () => {
        let result = [];
        let encountersCategoriesWithoutVillain = EncounterUtils.getEncounterCategoriesWithoutVillains();

        result.push('STANDARD');
        for (let item of encountersCategoriesWithoutVillain) {
          if (Math.random() >= 0.5 && !result.includes(item)) {
            result.push(item);
          }
          if (result.length > this.formGroup.value.encounterNumber) {
            break;
          }
        }
        if (result.length === 0) {
          result = ['STANDARD', 'BOMB_SCARE', 'EXPERT'];
        }
        return result;
      };

      selectedBossModule = {
        id: 'random',
        name: 'Random',
        modularDeckKeys: [] // randomCardsEncounterCategoryWithoutVillain() // keyforge
      };
    }
    // const modularDeckKeys = this.formGroup.value.boss;

    const villainCards: Cards = EncounterUtils.getVillainsCards(
      this.formGroup.value.boss,
      selectedBossModule.modularDeckKeys,
      ['SPIDER_MAN'] // this.formGroup.value.champions
    );

    this.cardsBucket = { villain: CardUtils.generateCardsId(villainCards) };
    CardUtils.shuffle(this.cardsBucket.villain.deck); // Keyforge

    const players = this.formGroup.get('players').value;
    for (let i = 0; i < players.length; i++) {
      // @Input playerDeck {name: string, uid: string, content: Card[]}
      // @Output playerCardBucket {champion: Card[], deck: Card[]}
      const playerDeckToPlayerCardBucket = (playerDeck) => {
        let cards = [];
        // playerDeck.content = MOCKED_PLAYERS[0].deck.content; // keyforge mock
        // console.log("zimbabwééé", playerDeck.content);

        for (let card of playerDeck.content) {
          for (let i = 0; i < card.counter; i++) {
            cards.push(card.card);
          }
        }

        let result = {
          champion: [],
          deck: cards // TODO MAYBE NEED FIX AND ADD ID CardUtils.generateCardsId(cards) // TODO verify if generateCardsId required
        };

        // TODO: will be added later as a parameter in board game settings
        // add champion card
        let putLastCardIn = { containerName: 'champion', tag: Tag.CHAMPION };
        if (putLastCardIn) {
          const cardIndex: number = result.deck.findIndex(card =>
            card.metadatas.tags.includes(putLastCardIn.tag)
          );
          result[putLastCardIn.containerName].push(result.deck[cardIndex]);
          result.deck.splice(cardIndex, 1);
        }
        if (!result.champion[0]) {
          throw 'Room-Creation: No champion found';
        }

        return result;
      }

      let playerDeck = players[i].deck;
      playerDeck = MOCKED_PLAYERS[0].deck; // keyforge
      console.log('pourt', playerDeck, i, players);
      this.cardsBucket['player' + (i + 1)] = playerDeckToPlayerCardBucket(
        playerDeck
      );
    }

    this.addRoom();
  }

  addRoom() {
    const counters = {
      villain: { first: 2, second: 0 },
      player1: { first: 1, second: 0 },
      player2: { first: 1, second: 0 }
    };
    const users = [
      {
        name: this.user.displayName,
        uid: this.user.uid,
        roles: ['host', 'player'],
        activePlayer: true
      }
    ];

    this.roomService.addRoom(
      users,
      this.roomCreationId,
      this.cardsBucket,
      counters
    );
    const createdRoomUrl = `https://card-engine.firebaseio.com/rooms/${
      this.user.uid
    }`;
    this.roomService.createdRoomUrl = createdRoomUrl + '';
    const roomId = this.roomService.createdRoomUrl.split('/').pop();
    this.formGroup.get('roomId').setValue(roomId);
    this.formGroup.get('tabKey').setValue('gameInProgress');

    this.router.navigate(['/mc/play/' + roomId]);
  }

  updateHub(roomId, data) {
    this.hubService.updateHub(roomId, data);
  }

  openSnackBar(message: string, action: string) {
    /* this.snackBar.open(message, action, {
      duration: 2000
    }); */
  }

  onSubmit() {
    this.createGameDatas();
    /* if (this._userRestrictions.startGame) {
      this.createGameDatas();
    } else  {
      this.openSnackBar('Only host can start the game', '⚠️');
    } */
  }

  nbSpectators() {
    const spectators = this.formGroup.value.spectators;
    return spectators && spectators.length
      ? '(+' + spectators.length + ' spectators)'
      : '';
  }

  playerSelectedChampionId(inputPlayer): string {
    const player = this.formGroup
      .get('players')
      .value.find(player => player.uid === inputPlayer.uid);
    return player && player.deck ? player && player.deck.uid : null;
  }

  // FAIL
  changePlayerSelectedChampionId(event, player) {
    const deckId = event.value;
    const decks = localStorage.getItem('decks')
      ? JSON.parse(localStorage.getItem('decks'))
      : [];
    const deck = decks.find(deck => deck.uid === deckId);

    let playersCopy = [...this.formGroup.get('players').value];
    playersCopy.find(
      playerCopy => playerCopy.uid === this.user.uid
    ).deck = deck;
    this.formGroup.get('players').setValue(playersCopy);
  }
}
